import { render, staticRenderFns } from "./LayoutPanel.vue?vue&type=template&id=10534bf7&scoped=true"
import script from "./LayoutPanel.vue?vue&type=script&lang=js"
export * from "./LayoutPanel.vue?vue&type=script&lang=js"
import style0 from "./LayoutPanel.vue?vue&type=style&index=0&id=10534bf7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10534bf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10534bf7')) {
      api.createRecord('10534bf7', component.options)
    } else {
      api.reload('10534bf7', component.options)
    }
    module.hot.accept("./LayoutPanel.vue?vue&type=template&id=10534bf7&scoped=true", function () {
      api.rerender('10534bf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/LayoutPanel.vue"
export default component.exports